export default "__VITE_ASSET__CEXXzzNG__"